import React from 'react'
import Header1 from '../component/Header1'
import Legend from '../component/Legend'
import Credits from '../component/Credits'
import { makeStyles } from '@material-ui/core/styles'
import Foto3 from '../images/informe2foto3.jpg'
import Foto2 from '../images/informe2foto2.jpg'
import Foto1 from '../images/informe2foto1.jpg'
import { Helmet } from 'react-helmet'

const useStyles = makeStyles(theme => ({
  text: {
    maxWidth: 800,
    margin: '1em auto',
    fontSize: 16,
    fontFamily: 'Roboto Slab',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
      paddingRight: 20
    }
  },
  content: {
    position: 'relative',
    background: '#fff',
    paddingTop: '4em',
    paddingBottom: '4em'
  }
}))

const Informe2 = () => {
  const classes = useStyles()
  const bajada =
    'Se agotan las fuentes de agua dulce. El reflejo de ello era la laguna Piuray, cuyo embalse se redujo en forma notable a finales de los noventa. Hace siete años Sedacusco aplica un modelo para recargar este espejo. En este esfuerzo participan desde el comunero hasta el usuario que paga la factura. Lamentablemente, no todas las regiones del sur tienen este ejemplar emprendimiento.'

  return (
    <div>
      {/*<Helmet title="Cómo cuida Cusco el agua que toma">
        <meta charSet="utf-8" />
        <link rel="canonical" href="https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua/como-cuida-cusco-agua" data-react-helmet="true" />
        <meta property="og:url" data-react-helmet="true" content="https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua/como-cuida-cusco-agua" />
				<meta name="description" data-react-helmet="true" content="Se agotan las fuentes de agua dulce. El reflejo de ello era la laguna Piuray, cuyo embalse se redujo en forma notable a finales de los noventa." />
				<meta property="og:description" data-react-helmet="true" content="Se agotan las fuentes de agua dulce. El reflejo de ello era la laguna Piuray, cuyo embalse se redujo en forma notable a finales de los noventa." />
				<meta property="og:title" data-react-helmet="true" content="Cómo cuida Cusco el agua que toma" />
  </Helmet>*/}
      <Helmet
      title="Cómo cuida Cusco el agua que toma"
      meta={[
        { property: "og:title", content: "Cómo cuida Cusco el agua que toma" },
        { property: "description", content: "Se agotan las fuentes de agua dulce. El reflejo de ello era la laguna Piuray, cuyo embalse se redujo en forma notable a finales de los noventa." }
        // Any other meta tags go here as objects or you can just add children directly inside this component.
      ]}
    />
      <Header1
        bajada={bajada}
        title={'Cómo cuida Cusco el agua que toma'}
        legend="Foto: Aquilino Levita Condori y su esposa Diana Carolina."
        image={Foto1}
      />
      <div className={classes.content}>
        <div className={classes.text}>
          <Credits>
            <p>Texto: Elmer Mamani, Melissa Valdivia y Rufino Motta</p>
            <p>Fotos: Melissa Valdivia</p>
          </Credits>
          <br></br>
          <p>
            El antiguo Cusco, según la leyenda, está sumergido en las aguas de
            Piuray. El mito revela que un anciano harapiento y sucio inundó tres
            kilómetros cuadrados al tocar el suelo con su bastón. Así castigó a
            sus habitantes por rechazarlo. Solo una mujer con un bebé en brazos
            lo había socorrido. En agradecimiento, el veterano personaje le
            pidió que huya al cerro más alto sin mirar atrás. Pero la mujer
            desobedeció la orden y, mientras observaba cómo se formaba la
            inmensa laguna de casi 60 millones de metros cúbicos, se petrificó.
            “El anciano era el Apu, era Dios”, dice Aquilino Levita Condori,
            dando cuenta de una leyenda que en su comunidad circula de
            generación en generación.
          </p>
          <p>
            A diario Aquilino realiza una expedición por las riberas de este
            espejo de agua y recoge todos los residuos. “Retiro plásticos. A
            veces perros muertos”, explica cerca a la orilla, mientras el viento
            golpea su rostro de 34 años. Trabaja hace 7 años para Sedacusco, la
            empresa que potabiliza el recurso hídrico para los habitantes de las
            provincias de Cusco y Paucartambo. El comunero tiene la misión de
            proteger el Piuray.
          </p>
          <p>
            A este reservorio natural, en el distrito de Chinchero, provincia
            cusqueña de Urubamba, lo rodean 20 comunidades. Más allá corona el
            paisaje un conjunto de montañas. El protector de la laguna y su
            esposa, Diana Carolina, crecieron y se conocieron en los alrededores
            de Piuray, un ecosistema al que no se tarda más de una hora en
            llegar desde la Ciudad Imperial. Sus vidas, como las de los demás
            pobladores, están marcadas por estas aguas. Lo último y primero que
            ven.
          </p>
          <p>
            Pero no solo con la limpieza se puede preservar este ecosistema. En
            las faldas de uno de esos cerros, Sedacusco construyó
            &quot;infraestructura verde&ldquo; para garantizar el almacenamiento.
          </p>
          <p>
            La laguna se alimenta de más de 60 acuíferos provenientes de 9
            sistemas de la microcuenca Piuray–Ccorimarca en la parte alta. El
            líquido viaja desde las montañas para recargar la laguna. El primer
            sistema que se intervino (46 hectáreas) se llama Can Can. Llegar a
            Can Can no demora más de 30 minutos desde Piuray. Para eso
            ascendemos por un camino de trocha en una camioneta. “Todos estos
            terrenos son de propiedad comunal. Nos los fueron cedidos bajo
            convenio para trabajar y cuidar el agua”, nos explica el supervisor
            de obra de Sedacusco, Eric Villavicencio. A los 4 300 metros sobre
            el nivel del mar, nos detenemos. Desde este punto se tiene un
            panorama amplio de todos los trabajos. Lo ejecutado se asemeja a las
            líneas de Nazca.
          </p>
          <p>
            Es una primera impresión, pero en realidad son kilómetros de
            serpenteantes zanjas de infiltración. Con esta técnica ancestral, el
            agua de las lluvias llega a los acuíferos que alimentan a Piuray. En
            el medio hay dos espejos de agua que cumplen la misma función.
          </p>
          <br></br>
          <br></br>
        </div>
        <img
          src={Foto2}
          alt="Cómo cuida Cusco el agua que toma"
          style={{ maxWidth: '100%' }}
        />
        <Legend>Siembra del &quot;colle&ldquo;, una planta considerada como llamadora de agua.</Legend>
        <div className={classes.text}>
          <br></br>
          <p>
            No hay nada al azar. Con pruebas de hidrología determinaron los
            puntos exactos donde están los manantes para hacer las zanjas con
            cero grados de pendiente en la superficie. Para aprovechar al máximo
            las lluvias, colocaron alrededor pastos que evitan que los canales
            se colmaten con tierra. “Los acuíferos no estaban funcionando en su
            real dimensión. Estamos reactivándolos”, advierte Villavicencio.
            Esta zona es cabecera de cuenca y estuvo deforestada, lo que impedía
            infiltración de las precipitaciones. Por eso sembraron desde ichu,
            hasta colle y queñua, plantas llamadoras de agua. Sensores
            instalados determinarán su real efectividad en cuestión de meses.
          </p>
          <p>
            En un breve recorrido, Villavicencio nos muestra otras estrategias
            incas que replicaron en el lugar. Por ejemplo, las patapatas, una
            pila de piedras dispuestas como andenes que protege los canales de
            infiltración, o el control de cárcavas, barreras naturales también
            de piedras para detener los sedimentos que arrastran las lluvias.
          </p>
          <p>
            Todas estas intervenciones se realizaron en el marco de la Ley Nº
            30125 de Mecanismos de Retribución por Servicios Ecosistémicos
            (MERESE) del 2014. Las Empresas Prestadoras de Servicios (EPS) del
            país están implementando este instrumento para conservar o recuperar
            sus fuentes de agua. Sedacusco ya cumplió su primer quinquenio con
            los MERESE (2013- 2018). La norma, en parte, fue empujada por un
            conflicto social.
          </p>
          <p>
            Históricamente, Piuray fue la principal proveedora para abastecer de
            agua a Cusco en los últimos 70 años. “Cubría el 90% de lo que
            demandaba esta ciudad hasta el 2000”, explica Álvaro Flores, gerente
            de la EPS. En la actualidad esto se redujo a 30% para un uso
            equilibrado.
          </p>
          <p>
            El nivel del espejo actualmente es óptimo, pero no fue así 20 años
            antes. El protector de la laguna, Aquilino, tenía 17 años cuando
            Piuray iba reduciéndose drásticamente por la falta de lluvias por el
            fenómeno de El Niño y el ininterrumpido uso de Sedacusco para
            potabilizar sus aguas. “La gente se asustó”, recuerda Aquilino,
            cuando tres deslizamientos se tragaron 100 hectáreas, muchas de
            ellas de cultivos y dos casas, entre 1998 y 2000. Las aguas de
            Piuray se contrajeron y la tierra de las riberas cedió.
          </p>
          <p>
            Con la catástrofe, las comunidades culparon a la EPS. Constantino
            Sallo recuerda que realizaron marchas exigiendo una compensación:
            “No hay que ser experto para darse cuenta de que hubo una
            sobreexplotación”. En ese entonces, Sallo era presidente del Comité
            de Gestión de la Microcuenca Piuray-Ccorimarca. Hoy es fiscal. De
            este conflicto nació el convenio tripartito entre la municipalidad
            de Chinchero, Sedacusco y el comité, en 2013.
          </p>
          <p>
            Determinaron destinar 4.8% (S/ 1.20 a S/ 1.50 promedio-uso
            doméstico) de lo pagado en cada recibo. El fondo debe invertirse en
            infraestructura verde y proteger Piuray. Esa es la esencia de los
            MERESE. Un año después nace la ley inspirada en el problema y
            solución cusqueños.
          </p>

          <br></br>
          <br></br>
        </div>
        <img
          src={Foto3}
          alt="Cómo cuida Cusco el agua que toma"
          style={{ maxWidth: '100%' }}
        />
        <Legend>Laguna de Piuray. El primer sistema en el que intervino SEDA Cusco sobre infraestructura verde.</Legend>
        <div className={classes.text}>
          <br></br>
          <p>
            Con la mayor ocurrencia de eventos naturales extremos, la seguridad
            hídrica es más incierta. “Hay pronósticos de que por el cambio
            climático las lluvias podrían disminuir en 30% al 2050 en Cusco”,
            advierte Villavicencio. Es por eso que Sedacusco invirtió su fondo,
            6 millones 579 mil soles, para resguardar Piuray a través de 7
            proyectos en el último quinquenio.
          </p>
          <p>
            También se efectuó obras de desagüe en comunidades cercanas. Eso
            evitará que los residuos fecales de los pobladores contaminen en
            época de lluvias las fuentes naturales.
          </p>
          <p>
            Para el siguiente quinquenio 2019 - 2024, planean construir más
            infraestructura natural para Piuray, pero esta vez al lado de Can
            Can, en el sistema Millpo, una montaña altamente erosionada. Además,
            empezarán a trabajar con otras fuentes: Vilcanota, Paucartambo,
            Jaquira y Salkantay. Estiman recaudar e invertir 7 millones 733 mil
            soles. “Apuntamos a hacer un trabajo integral de todas las fuentes.
            Con la experiencia de estos primeros cinco años, ahora tenemos que
            perfeccionarlos”, apunta Villavicencio.
          </p>
          <p>
            Las demás EPS de Cusco van por ese camino, aunque con dificultades.
            A parte de Sedacusco, está Emsapa (Calca), Empssapal S.A. (Sicuani y
            Santo Tomás) y Emaq (Quillabamba). Las tres últimas realizaron su
            reajuste tarifario para recaudar fondos por los MERESE.
          </p>
          <p>
            Por ejemplo, Emsapa es una empresa chica con no más de 4 mil
            usuarios. Es necesario intervenir y proteger sus fuentes: 22
            manantiales en ambas márgenes del río Cochocc. Y es que en solo tres
            años presentaron una histórica reducción de entre 30% y 80%. “De 20
            litros por segundo ahora solo emana 2 litros”, explica el gerente de
            esa EPS, José Deza. El principal problema es la destrucción de la
            cobertura vegetal. Pobladores de las comunidades de Accha Baja, Acha
            Baja y Ayaccaca cambiaron los pastos para colocar pinos y otras
            especies.
          </p>

          <p>
            En noviembre del 2018, la EPS empezó a cobrar el 1% de los recibos
            para fondo. Tras un año, sólo se recaudó 60 mil soles. “Con ese
            dinero no podemos empezar nada”, advierte Deza. Emsapa tendrá que
            buscar socios estratégicos para desarrollar sus proyectos, señala el
            funcionario.
          </p>
          <p>
            Si damos una mirada a la aplicación de los MERESE en las EPS del
            sur, es dispareja. Existen 13 en Arequipa (1), Puno (5), Cusco (4),
            Moquegua (2) y Tacna (1). De ellas, solo 6 ya vienen cobrando el
            fondo para invertirlo en infraestructura verde. Es decir, solo el
            46% de las empresas está aplicando la norma.
          </p>
          <br></br>
          <br></br>
        </div>
      </div>
    </div>
  )
}

export default Informe2
